import React from 'react';
import PropTypes from 'prop-types';
import { Button } from './CreateUserButton.styles';
import { FaUserPlus } from 'react-icons/fa';

const CreateUserButton = ({ onClick }) => {
  return (
    <Button onClick={onClick}>
      <FaUserPlus />
      Criar Usuário
    </Button>
  );
};

CreateUserButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CreateUserButton;
